<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="true">
  <div>
    <h2 class="ds-title-3">{{'GROW.deposit.fundModal.title' | translate}}</h2>
    <p class="ds-running-1">{{'GROW.deposit.fundModal.description' | translate}}</p>
    <div class="explanation-list">
      <ul class="ds-list">
        <li>
          <app-ds-rounded-icon icon="landmark" variant="custom" customColor="var(--color-core-brand-2-2)"></app-ds-rounded-icon>
          <div>
            <p class="ds-heading-3">{{'GROW.deposit.fundModal.li1.title' | translate}}</p>
            <p class="ds-ui-2 ds-color-core-neutral-8" [innerHTML]="'GROW.deposit.fundModal.li1.description' | translate"></p>
          </div>
        </li>
        <li>
          <app-ds-rounded-icon icon="shuffle" variant="custom" customColor="var(--color-core-brand-6-2)"></app-ds-rounded-icon>
          <div>
            <p class="ds-heading-3">{{'GROW.deposit.fundModal.li2.title' | translate}}</p>
            <p class="ds-ui-2 ds-color-core-neutral-8" [innerHTML]="'GROW.deposit.fundModal.li2.description' | translate"></p>
          </div>
        </li>
      </ul>
      <h2 class="ds-heading-2">{{'GROW.deposit.fundModal.intendToInvestHeading' | translate}}</h2>
    </div>
    <app-ds-button variant="primary" (clicked)="onOpenDepositModal()">{{'GROW.deposit.fundModal.proceedButton' | translate}}</app-ds-button>
    <app-ds-button variant="outline" (clicked)="onCloseFundModal()">{{'GROW.deposit.fundModal.notNowButton' | translate}}</app-ds-button>
  </div>
</ion-content>
